import { render, staticRenderFns } from "./crmToolbar.vue?vue&type=template&id=681c0b53&scoped=true"
import script from "./crmToolbar.vue?vue&type=script&lang=js"
export * from "./crmToolbar.vue?vue&type=script&lang=js"
import style0 from "./crmToolbar.vue?vue&type=style&index=0&id=681c0b53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c0b53",
  null
  
)

export default component.exports